<template>
  <q-table
    v-show="!downloadProgress"
    v-bind="mergedAttrs"
    ref="table"
    class="lwf-table"
    :filter="filter"
    :class="{ selectable: $attrs.selection }"
    card-container-class="scroll"
    v-on="$listeners"
  >
    <template #top-left>
      <span
        v-if="mergedAttrs.title"
        class="text-h6"
      >{{ mergedAttrs.title }}</span>
      <q-input
        v-model="filter"
        type="search"
        :debounce="400"
        dense
        label="Rechercher"
      >
        <template #append>
          <q-icon name="fa fa-search" />
        </template>
      </q-input>
    </template>
    <template #loading>
      <q-inner-loading
        showing
        color="primary"
      />
    </template>
    <template
      v-for="(slot, k) in $slots"
      #[k]
    >
      <slot :name="k" />
    </template>
    <template
      v-for="(slot, k) in $scopedSlots"
      #[k]="props"
    >
      <slot
        :name="k"
        :scope="props"
        v-bind="props"
      />
    </template>
  </q-table>
</template>

<script>
import { DATATABLE_ROWS_PER_PAGE_OPTIONS } from '@/consts/app'
import { exportTable } from '@/utils'
import { QSpinnerGears } from 'quasar'
import { toast } from '@/utils/ui'

const MAX_ROWS_EXPORT = 5000
export default {
  name: 'LwfTable',
  provide () {
    return { table: this }
  },
  inheritAttrs: false,
  props: {
    selectable: Boolean
  },
  data () {
    return {
      filter: '',
      downloadProgress: false
    }
  },
  computed: {
    mergedAttrs () {
      return {
        ...this.$attrs,
        rowsPerPageOptions: DATATABLE_ROWS_PER_PAGE_OPTIONS
      }
    }
  },
  methods: {
    async download () {
      const _download = () => {
        this.$nextTick(() => {
          const table = $refTable.$el.querySelector('table')
          exportTable(table)
          $refTable.setPagination(pagination)
        })
      }
      const $refTable = this.$refs.table
      const { pagination = {} } = $refTable
      if (pagination.rowsNumber && pagination.rowsNumber > MAX_ROWS_EXPORT) {
        return toast.negative(`L'export excel est limité à ${MAX_ROWS_EXPORT} lignes`)
      }
      $refTable.setPagination({ rowsPerPage: 0 })
      if (pagination.rowsNumber) {
        this.downloadProgress = true
        this.$q.loading.show({
          message: 'Génération du document...',
          spinner: QSpinnerGears
        })
        const unwatch = $refTable.$watch('data', (n, v) => {
          unwatch()
          $refTable.$nextTick(() => {
            _download()
            const unwatch = $refTable.$watch('data', (n, v) => {
              unwatch()
              this.downloadProgress = false
              this.$q.loading.hide()
            })
          })
        })
      } else {
        _download()
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.lwf-table
  color $primaryApp

.q-dark.lwf-table
  color white
</style>
